/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Avatar, Box, Card, Skeleton, Text, Title } from "@mantine/core";
import {
  fetchAuthSession,
  fetchUserAttributes,
  FetchUserAttributesOutput
} from "aws-amplify/auth";
import { getUrl } from "aws-amplify/storage";
import { useEffect, useState } from "react";
import { useUserProvider } from "../../utils/UserProvider";
import UserStats from "../Profile/UserStats";
interface userStatsProps {
  showHeader: boolean;
}
function UserComponent({ showHeader = true }: userStatsProps) {
  const [loading, setLoading] = useState(false);
  const { amplifyUser } = useUserProvider();
  const [profileImage, setProfileImage] = useState(
    "profile-image-placeholder.jpeg"
  );
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      setLoading(true);
      const userInfo: FetchUserAttributesOutput = await fetchUserAttributes();
      setName(userInfo.name!);
      setEmail(userInfo.email!);
      const identityId = (await fetchAuthSession()).identityId;
      if (userInfo.picture) {
        // const s3Image = await Storage.get(userInfo.picture, { level: 'private' });
        const s3Image = (
          await getUrl({
            path: `private/${identityId}/${userInfo.picture}`,
            options: { validateObjectExistence: true }
          })
        ).url.toString();

        setProfileImage(s3Image);
      } else {
        // const s3Image = await Storage.get('pet-image-placeholder.png', { level: 'public' });
        const s3Image = (
          await getUrl({
            path: "public/pet-image-placeholder.png",
            options: { validateObjectExistence: true }
          })
        ).url.toString();
        setProfileImage(s3Image);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }

  return (
    <>
      {loading && <Skeleton h={380} />}
      {!loading && (
        <>
          {showHeader && (
            <Card p={0} withBorder shadow="md">
              <Card shadow="0" padding="xl" radius="">
                <Card.Section
                  h={140}
                  style={{
                    backgroundImage:
                      "linear-gradient(to right, #003554, #1a4a6b, #2d5f82, #3f7499, #0582CA)"
                  }}
                >
                  <Title
                    size="20"
                    fw={"500"}
                    c={"white"}
                    ta={"center"}
                    mt={"50"}
                  >
                    Welcome back, {name || amplifyUser?.email}!
                  </Title>
                </Card.Section>
                <Box className="box-avatar">
                  <Avatar src={profileImage} size={80} radius={80} mx="auto" />
                </Box>
                <Text ta="center" fz="sm" mt={"sm"} c="dimmed">
                  {email}
                </Text>
              </Card>
            </Card>
          )}
          <UserStats amplifyUser={amplifyUser} showHeader={showHeader} />
        </>
      )}
    </>
  );
}

export default UserComponent;
